import BaseComponent from "../baseComponent.js";
import UniqueIdGenerator from "../../core/utils/uniqueIdGenerator";

import styles from './modal.scss';

export default class Modal extends BaseComponent {
  constructor(props) {
    super(props);
    this.modalId = UniqueIdGenerator.id();
  }

  componentDidMount() {
    this.$modal = $('#' + this.modalId);
    this.$modal.modal({
      dismissible: false,
      ready: (modal, trigger) => {
        // header has z-index of 10000 to avoid flickering text
        $(modal).css("z-index", 11002);
        $(".modal-overlay").last().css("z-index", 11001);
      },
    });
  }

  show() {
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  render() {
    const {confirmLabel, cancelLabel, width, confirm, children} = this.props;
    return (
      <div id={this.modalId} className={[styles.modal, "modal"].join(' ')} style={{width: width || ''}}>
        <div className="modal-content">
          {children}
        </div>
        <div className={styles.footer}>
          <button
            className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')}>
            {cancelLabel || 'discard'}
          </button>
          <button className={[styles.actionButton, "btn waves-effect"].join(' ')} onClick={confirm}>
            {confirmLabel || 'update'}
          </button>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/common/modal.jsx